// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-item .el-select__caret{color:var(--primary-400)!important;font-size:.18rem!important;font-weight:700}.select-item .el-input.is-focus .el-input__inner{border-color:var(--primary-400)!important}.select-item .el-input__inner{color:#000}.select-item .el-input__inner:focus{border-color:var(--primary-400)}.select-item.is-select .el-input__inner{background-color:var(--brand-50);border:.01rem solid var(--primary-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
